import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core';
import { useErrorBoundary } from 'use-error-boundary';

import DataProvider from '../data/DataProvider';
import { extServiceCheck } from '../data/DataLoader';
import queryString from 'query-string';
import Maintenance from './Maintenance';
import Sorry from './Sorry';
import Intro from './Intro';
import DeliveryIntro from './DeliveryIntro';
import Loading from './Loading';
import loadJs from 'load-js';
import InputProvider from '../data/InputProvider';
import Layout from './Layout';

const styles = (theme) => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.color.background,
    overflow: 'none',
    '-webkit-overflow-scrolling': 'touch',

    // Default Font Settings
    font: '-apple-system-body',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.54,
    letterSpacing: 'normal',
  },
});

const stagePrefixMap = {
  'chat-st': 'st',
  'chat-qa': 'qa',
  chat: 'op',
  'chat-st-us': 'st',
  'chat-qa-us': 'qa',
  'chat-us': 'op',
};

function getCurrentStage() {
  let currentUrlHost = window.location.host.split('.');
  let stagePrefix = currentUrlHost[0];
  let currentStage = 'st';
  if (stagePrefix in stagePrefixMap) {
    currentStage = stagePrefixMap[stagePrefix];
  }
  return currentStage;
}

const countryPrefixMap = {
  'chat-st-us': 'us',
  'chat-qa-us': 'us',
  'chat-us': 'us',
};

function getCurrentCountry() {
  let currentUrlHost = window.location.host.split('.');
  let prefix = currentUrlHost[0];
  let country = 'kr';
  if (prefix in countryPrefixMap) {
    country = countryPrefixMap[prefix];
  }
  return country;
}

const projectCodeMap = {
  'chat-st': 'lgecomkr',
  'chat-qa': 'lgecomkr',
  chat: 'lgecomkr',
  'chat-st-us': 'lgcomus', // 미국 projectCode는 미정 추후변경요망
  'chat-qa-us': 'lgcomus', // 미국 projectCode는 미정 추후변경요망
  'chat-us': 'lgcomus', // 미국 projectCode는 미정 추후변경요망
};

function getCurrentProjectCode() {
  let currentUrlHost = window.location.host.split('.');
  let prefix = currentUrlHost[0];
  let projectCode = 'lgecomkr'; //default 'lgecomkr'
  if (prefix in projectCodeMap) {
    projectCode = projectCodeMap[prefix];
  }
  return projectCode;
}

function getClient() {
  return 'lgcom';
}

function getChannelParams(props) {
  var channel = 'unknown';
  var channelParams = {
    code: null,
    sppech: '',
    service: '',
    locale: '',
    params: null,
    callback: '',
  };
  try {
    const parameters = queryString.parse(props.location.search);
    console.log('parameters', parameters);

    // if (!("channel" in parameters) || !"channel_parameters") {
    //   throw new Error("channel or channel_parameters is not exist");
    // }

    if ('channel' in parameters) {
      channel = parameters['channel'];
    }

    if ('code' in parameters) {
      channelParams['code'] = parameters['code'];
    }

    if ('speech' in parameters) {
      channelParams['speech'] = parameters['speech'];
    }

    if ('service' in parameters) {
      channelParams['service'] = parameters['service'];
    }

    if ('locale' in parameters) {
      channelParams['locale'] = parameters['locale'];
    }

    if ('params' in parameters) {
      channelParams['params'] = JSON.parse(decodeURI(parameters['params']));
    }

    if ('callback' in parameters) {
      channelParams['callback'] = parameters['callback'];
    }

    if ('seq_no' in parameters) {
      channelParams['seq_no'] = parameters['seq_no'];
    }
    console.log('[Main.js]', 'channelParams', channelParams);

    // Get Parameters로 얻어온 데이터를 Context에 저장하고 URL 창에 보여주지 않는다.
    window.history.replaceState({}, null, props.location.pathname);
  } catch (e) {
    console.log('Main.js:', e.message);
  }
  return { channel, channelParams };
}

const notSupportedChannel = {
  lg_pc: {
    redirectChannel: 'lg_pc2',
  },
};

const needIntroChannel = ['unknown', 'lg_pc'];

function Main(props) {
  const { classes } = props;

  const [introButton, setIntroButton] = useState('');
  const [deliveryIntroButton, setDeliveryIntroButton] = useState('');

  const location = window.location + props.location.search;

  let { channel, channelParams } = getChannelParams(props);

  const currentStage = getCurrentStage();
  let countryCode = '';
  let languageCode = '';

  if (channelParams['locale']) {
    [languageCode, countryCode] = channelParams['locale'].split('-'); // ko-KR, en-US
    countryCode = countryCode.toLowerCase(); // [230206][minseok.seo]'kr'로 hardcoding되어있는 부분이 많아 일단 lowercase로 통일
  } else {
    countryCode = getCurrentCountry(); //props.match.params.countryCode ?? 'kr';
    languageCode = countryCode === 'kr' ? 'ko' : 'en';
  }

  const projectCode = getCurrentProjectCode();

  const client = getClient();

  const [maintenanceInfo, setMaintenanceInfo] = useState(null);
  const [isLoadingComplete, setIsLoadingComplete] = useState(false);

  function isIOS() {
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    console.log('UserAgent', varUA);
    if (varUA.indexOf('android') > -1) {
      //안드로이드
      return false;
    } else if (
      varUA.indexOf('iphone') > -1 ||
      varUA.indexOf('ipad') > -1 ||
      varUA.indexOf('ipod') > -1
    ) {
      //IOS
      return true;
    } else {
      //아이폰, 안드로이드 외
      return false;
    }
  }

  async function doServiceCheck() {
    try {
      let serviceChk = await extServiceCheck(
        countryCode,
        currentStage,
        projectCode,
        client
      );

      // 이미 새로고침했는지 체크
      // if (!sessionStorage.getItem('refreshed')) {
      //   // 새로고침이 필요하다고 판단되면
      //   sessionStorage.setItem('refreshed', 'true');
      //   const url =
      //     window.location.origin +
      //     window.location.pathname +
      //     '?_=' +
      //     new Date().getTime();
      //   window.location.href = url; // 페이지 강제 새로고침
      //   return; // 이후 코드 실행 안 함
      // }

      // // 여기서부터는 새로고침 후에 실행될 코드
      // let serviceChk = {
      //   result: {
      //     service: 'lgecomkr',
      //     check: true,
      //     since: '2025-05-22-10-30',
      //     until: '2025-05-22-24-00',
      //     reason: 'serviceCheck',
      //   },
      // };
      console.log(serviceChk);
      serviceChk.result.since = serviceChk.result.since.replaceAll('-', '.');
      serviceChk.result.until = serviceChk.result.until.replaceAll('-', '.');
      setMaintenanceInfo(serviceChk.result);

      // 필요하면 sessionStorage 재설정
      // sessionStorage.removeItem('refreshed');
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    // OP 인 경우 로그 삭제!
    if (currentStage.toLowerCase() === 'op') {
      window['console']['log'] = function () {};
    }
    doServiceCheck();
  }, []);

  const { ErrorBoundary } = useErrorBoundary();

  const handleReload = () => {
    console.log('handleReload', location);
    window.location = location;
  };

  const handleReloadNotSupportedChannel = (channel) => {
    console.log('handleReloadWOChannel', location);
    const redirectChannel = notSupportedChannel[channel].redirectChannel;

    const newParam = Object.keys(channelParams).reduce((tempParam, curKey) => {
      if (channelParams[curKey]) {
        tempParam = `${tempParam ? tempParam + '&' : ''}${curKey}=${
          channelParams[curKey]
        }`;
      }
      return tempParam;
    }, `channel=${redirectChannel}`);
    const redirectUrl = `${window.location.origin}${window.location.pathname}?${newParam}`;
    console.log(redirectUrl);
    window.open(redirectUrl, '_blank');
  };

  // 동적으로 네이버 맵 로드
  // 네이버 API 변경에 따른 맵관련 개발의 건 ncpClientId -> ncpKeyId 25-06
  loadJs(
    // 'https://oapi.map.naver.com/openapi/v3/maps.js?ncpClientId=iveo33q885&submodules=geocoder'
    'https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=djsn4tbicr&submodules=geocoder'
  );

  // seq_no가 존재할때 배송 Intro 화면표시
  if (!channelParams.seq_no && introButton === '' && needIntroChannel.includes(channel)) {
    return <Intro setIntroResult={(result) => setIntroButton(result)} />;
  } else if (channelParams.seq_no && deliveryIntroButton === '') {
    return <DeliveryIntro setIntroResult={(result) => setDeliveryIntroButton(result)} />;
  } else {
    return (
      <ErrorBoundary
        render={() => (
          <div className={classes.root}>
            <InputProvider>
              <DataProvider
                countryCode={countryCode}
                channel={channel}
                channelParams={channelParams}
                stage={currentStage}
                projectCode={projectCode}
                languageCode={languageCode}
                client={client}
              >
                {maintenanceInfo === null || isLoadingComplete === false ? (
                  <Loading
                    safari={isIOS()}
                    callbackFunc={() => setIsLoadingComplete(true)}
                    isLoadingComplete={isLoadingComplete}
                  />
                ) : // Object.keys(notSupportedChannel).includes(channel) ? (
                // <Sorry
                // sorryType={"not_support_channel"}
                // handleReload={()=>handleReloadNotSupportedChannel(channel)}
                // />
                // ) :
                maintenanceInfo?.check === true ? (
                  'error' in maintenanceInfo ? (
                    <Sorry
                      message={maintenanceInfo.error.statusText}
                      handleReload={handleReload}
                    />
                  ) : (
                    <Maintenance
                      since={maintenanceInfo.since}
                      until={maintenanceInfo.until}
                      // service={maintenanceInfo.service}
                      // reason={maintenanceInfo.reason}
                    />
                  )
                ) : (
                  <Layout />
                )}
              </DataProvider>
            </InputProvider>
          </div>
        )}
        renderError={({ error }) => <Sorry message={error} handleReload={handleReload} />}
      />
    );
  }
  // return (introButton===""&&(needIntroChannel.includes(channel)))?(
  //   <Intro setIntroResult={(result)=>setIntroButton(result)}/>
  //   ):(
  //   <ErrorBoundary
  //     render={() => (
  //       <div className={classes.root}>
  //         <InputProvider>
  //           <DataProvider
  //             countryCode={countryCode}
  //             channel={channel}
  //             channelParams={channelParams}
  //             stage={currentStage}
  //             projectCode={projectCode}
  //             languageCode={languageCode}
  //             client={client}
  //           >
  //             {
  //               (maintenanceInfo === null || isLoadingComplete === false) ? (
  //                 <Loading safari={isIOS()} callbackFunc={() => setIsLoadingComplete(true)} isLoadingComplete={isLoadingComplete} />
  //               ) : (
  //                 (
  //                   // Object.keys(notSupportedChannel).includes(channel) ? (
  //                     // <Sorry
  //                       // sorryType={"not_support_channel"}
  //                       // handleReload={()=>handleReloadNotSupportedChannel(channel)}
  //                     // />
  //                   // ) :
  //                   (
  //                     (maintenanceInfo?.check === true) ? (
  //                       ("error" in maintenanceInfo) ? (
  //                         <Sorry
  //                           message={maintenanceInfo.error.statusText}
  //                           handleReload={handleReload}
  //                         />
  //                       ) : (
  //                         <Maintenance
  //                           since={maintenanceInfo.since}
  //                           until={maintenanceInfo.until}
  //                         // service={maintenanceInfo.service}
  //                         // reason={maintenanceInfo.reason}
  //                         />
  //                       )
  //                     ) : (
  //                       <Layout />
  //                     )
  //                   )
  //                 )
  //               )
  //             }
  //           </DataProvider>
  //         </InputProvider>
  //       </div>
  //     )}
  //     renderError={({ error }) => (
  //       <Sorry message={error} handleReload={handleReload} />
  //     )}
  //   />
  // );
}
export default withStyles(styles)(Main);
